import React, { useEffect, useState } from "react";
import useFilters from "../../../hooks/useFilters";
import { request } from "../../../utils/request";
import PageHeader from "../../general/PageHeader";
import Loader from "../../general/Loader";
import { getLink } from "../../../utils/helpers";
import { Link } from "react-router-dom";
import Pagination from "../../general/Pagination";

const Pacientes = () => {
    const [loading, setLoading] = useState(false);
    const [pacientes, setPacientes] = useState({});

    const { handleFilterChange, filtersQuery } = useFilters({buscar: null});

    const getPacientes = async (url) => {
        url = url ? url + "&limit=15" : `salud/pacientes?limit=15`;

        setLoading(true);

        const response = await request(url);

        setPacientes(response);

        setLoading(false);
    };

    useEffect(() => {
        getPacientes(`salud/pacientes${filtersQuery}`);
    }, [filtersQuery]);

     return <>
        <PageHeader title="Pacientes">
            <div className="col" style={{maxWidth: "512px"}}>
                <input
                    name='buscar'
                    onChange={(e) => handleFilterChange("buscar", e?.target.value)}
                    type='search'
                    placeholder='Buscar...'
                    className='form-control'
                />
            </div>
        </PageHeader>

        <div className='row'>
            <div className='col-md-12'>
                <div>
                    <div className='table-data'>
                        <table className='table table-data2'>
                            <thead>
                                <tr>
                                    <th colSpan={2}>Paciente</th>
                                    <th>Tipo Contacto</th>
                                    <th>Código</th>
                                    <th>Sexo</th>
                                    <th>Edad</th>
                                    <th>Grupo Sanguíneo</th>
                                    <th>Alergias</th>
                                    <th>Condiciones Médicas</th>
                                    <th>Contacto Emergencia</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading
                                    ? (<tr className="tr-shadow"><td colSpan={11}><Loader /></td></tr>)
                                    : (pacientes?.data?.length
                                        ? pacientes.data.map((paciente) => (<tr className="tr-shadow" key={`row-paciente-${paciente.id}`}>
                                            <td style={{padding: '5px', overflow: 'hidden'}}>
                                                <span className="page-title-foto m-0">
                                                    <img src={paciente.foto ?? '/images/icon/avatar.png'} alt={paciente.codigo} />
                                                </span>
                                            </td>
                                            <td>{paciente.nombre_completo}</td>
                                            <td>{paciente.tipo}</td>
                                            <td>{paciente.codigo}</td>
                                            <td>{paciente.sexo}</td>
                                            <td>{paciente.edad}</td>
                                            <td>{paciente.grupo_sanguineo}</td>
                                            <td>{paciente.alergias?.join(', ')}</td>
                                            <td>{paciente.condiciones_medicas?.join(', ')}</td>
                                            <td>
                                                {Object.entries(paciente?.contacto_emergencia ?? {}).map(([key, value]) => (
                                                    <div className="row" key={key}>
                                                        <strong className="capitalize">{key === 'Telefono' ? 'Teléfono' : (key === 'Relacion' ? 'Relación' : key)}:</strong>
                                                        <span className="col text-right">{value}</span>
                                                    </div>
                                                ))}
                                            </td>
                                            <td>
                                                <Link
                                                    to={getLink(
                                                        `/salud/pacientes/${paciente.id}`
                                                    )}
                                                    className="item"
                                                    title="Ver Paciente"
                                                >
                                                    <i className="fas fa-eye"></i>
                                                </Link>
                                            </td>
                                        </tr>))
                                        : <tr className="tr-shadow"><td colSpan={11}>No hay ninguna Visita creada.</td></tr>
                                    )
                                }
                            </tbody>
                        </table>

                        {pacientes?.links && (<Pagination links={pacientes.links} meta={pacientes.meta} getData={getPacientes} />)}
                    </div>
                </div>
            </div>
        </div>
     </>;
};

export default Pacientes;
